/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, convertHexToRGB } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// FIELD ERROR MESSAGE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	errormessage: {
		opacity: '0',
		display: 'block',
		color: convertHexToRGB(theme.color.attention.dark.swatch, 50),
		fontSize: pxToEm(14),
		marginTop: pxToEm(5),
		// animate in 
		animationName: 'fadeInDown',
		animationDelay: '0s',
		animationDuration: '.1s',
		animationFillMode: 'forwards',
	}
});